// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__27-9D","description":"PatientConsentPreview_description__2BKZB"};